import dashboard from "../../../assets/icons/dashboard.svg"
import activeDashboard from "../../../assets/icons/activeDashboard.svg"
import campaign from "../../../assets/icons/campaign.svg"
import activeCampaign from "../../../assets/icons/activeCampaign.svg"
import folder from "../../../assets/icons/folder.svg"
import activeFolder from "../../../assets/icons/activeFolder.svg"
import donate from "../../../assets/icons/donate.svg"
import activeDonate from "../../../assets/icons/activeDonate.svg"
import profile from "../../../assets/icons/profile.svg"
import activeProfile from "../../../assets/icons/activeProfile.svg"
import signOut from "../../../assets/icons/signOut.svg";
import { Link } from "react-router-dom"

const SidebarItems = ({pageTitle, closeMenu}) => {
    return ( 
        <div className="fixed grid gap-10 md:gap-8 font-medium lg:me-4 text-[15px]">
          <Link to={"/dashboard"} onClick={closeMenu} className="flex items-center gap-3 truncate">
            <span className="min-w-[18px]"><img src={pageTitle === "Dashboard" ? activeDashboard : dashboard} alt="" className="h-[18px]"/></span>
            <span className={`${pageTitle === "Dashboard" ? "text-brandGreen" : "text-black"} truncate`}>Dashboard</span>
          </Link>
          <Link to={"/dashboard/start-a-campaign"} onClick={closeMenu} className="flex items-center gap-3 truncate">
            <span className="min-w-[18px]"><img src={pageTitle === "createCampaign" ? activeCampaign : campaign} alt="" className="h-[18px]"/></span>
            <span className={`${pageTitle === "createCampaign" ? "text-brandGreen" : "text-black"} truncate`}>Create campaign</span>
          </Link>
          <Link to={"/dashboard/user-campaigns"} onClick={closeMenu} className="flex items-center gap-3 truncate">
            <span className="min-w-[18px]"><img src={pageTitle === "userCampaign" ? activeFolder : folder} alt="" className="h-[18px]"/></span>
            <span className={`${pageTitle === "userCampaign" ? "text-brandGreen" : "text-black"} truncate`}>Your campaigns</span>
          </Link>
          <Link to={"/dashboard/support-a-campaign"} onClick={closeMenu} className="flex items-center gap-3 truncate">
            <span className="min-w-[18px]"><img src={pageTitle === "Campaigns" ? activeDonate : donate} alt="" className="h-[18px]"/></span>
            <span className={`${pageTitle === "Campaigns" ? "text-brandGreen" : "text-black"} truncate`}>Support a campaign</span>
          </Link>
          <Link to={"/dashboard/profile"} onClick={closeMenu} className="flex items-center gap-3 truncate">
            <span className="min-w-[18px]"><img src={pageTitle === "Profile" ? activeProfile : profile} alt="" className="h-[18px]"/></span>
            <span className={`${pageTitle === "Profile" ? "text-brandGreen" : "text-black"} truncate`}>Profile</span>
          </Link>
          <Link to={"/dashboard/sign-out"} onClick={closeMenu} className="flex items-center gap-3 truncate hover:ps-2 transition-all duration-200 cursor-pointer rounded">
            <span className="min-w-[18px]"><img src={signOut} alt="" className="h-[18px]"/></span>
            <span className="truncate text-rose-500">Sign out</span>
          </Link>
        </div>
     );
}
 
export default SidebarItems;